import {
	Button,
	Checkbox,
	Col,
	Divider,
	Form,
	Input,
	InputNumber,
	Popconfirm,
	Row,
	Select,
	Typography,
	notification,
} from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomTable } from "../utils/CustomComponents";
import { franchises57Options } from "../../constants/Customer";
const { Title, Text } = Typography;

const optionsUnit = [
	{ value: "oz", label: "oz" },
	{ value: "lb", label: "lb" },
	{ value: "ton", label: "ton" },
	{ value: "gl", label: "gl" },
];

/**
 ** Options header (columns)
 */
const columns = [
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
		disabled: true,
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Unit Price",
		dataIndex: "unitPrice",
		key: "unitPrice",
		disabled: true,
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Unit Of Measurement",
		dataIndex: "unitOfMeasurement",
		key: "unitOfMeasurement",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Unit Price Conversion",
		dataIndex: "unitPriceConversion",
		key: "unitPriceConversion",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Unit Of Conversion",
		dataIndex: "unitOfConversion",
		key: "unitOfConversion",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "User",
		dataIndex: "user",
		key: "user",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
];

const Cog = (props) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [disabled, setDisabled] = useState(true);
	const [initialValues, setInitialValues] = useState({});
	const [optionsMeasurement, setOptionsMeasurement] = useState(
		optionsUnit.filter((o) => {
			return o.value === "gl" || o.value === "ton" || o.value === "lb";
		}),
	);
	const [optionsConversion, setOptionsConversion] = useState(optionsUnit);
	const [historyData, setHistoryData] = useState([]);
	const [availableProduction, setAvailableProduction] = useState(false);
	const [availableInventory, setAvailableInventory] = useState(false);
	const [availableLogistics, setAvailableLogistics] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();
	const [franchise, setFranchise] = useState("57Concrete");
	const [plants, setPlants] = useState([]);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getCog();
		getPlants();
	}, []);

	const getPlants = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			data.payload
				.filter((i) => i.name !== "Laredo")
				.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
			setPlants(list);
		} catch (err) {
			openNotification("error", "Error", "Error while trying to get plants");
			console.error(err.message);
			return null;
		}
	};

	const getCog = async () => {
		try {
			setLoading(true);
			let url = api + "/cog/get/" + props.match.params.id;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			setInitialValues({
				material: data.material,
				unitPrice: data.unitPrice,
				measurementUnit: data.unitOfMeasurement,
				unitPriceConversion: data.unitPriceConversion,
				conversionUnit: data.unitOfConversion,
				productionAvailable: data.productionAvailable || false,
				productionOrderNumber: data.productionOrderNumber || undefined,
				inventoryUnitOfMeasurement:
					data.inventoryUnitOfMeasurement || undefined,
				inventoryAvailable: data.inventoryAvailable || false,
				logisticsAvailable: data.logisticsAvailable || false,
				franchise: data.franchise || "57Concrete",
				code: data.code,
				plants: data.plants || [],
			});
			setAvailableProduction(data.productionAvailable || false);
			setAvailableInventory(data.inventoryAvailable || false);
			setAvailableLogistics(data.logisticsAvailable || false);
			setFranchise(data.franchise || "57Concrete");

			let history = [];

			data.history.map((item, key) => {
				history.push({
					key: key,
					date: Intl.DateTimeFormat("en-US", {
						year: "numeric",
						month: "numeric",
						day: "numeric",
						hour: "numeric",
						minute: "2-digit",
						second: "2-digit",
						hour12: true,
					}).format(new Date(item.createdAt || item.date)),
					unitPrice: item.unitPrice,
					unitOfMeasurement: item.unitOfMeasurement,
					unitPriceConversion: item.unitPriceConversion,
					user: item.user ? item.user.name : "-",
					unitOfConversion: item.unitOfConversion,
				});
			});

			setHistoryData(history);

			setLoading(false);
		} catch (err) {
			setLoading(true);
			openNotification("error", "Error", "Error while trying to get cog");
			console.error(err.message);
			return null;
		}
	};

	const updateCog = async (data) => {
		try {
			setLoading(true);

			let formData = {
				material: data.material,
				unitPrice: data.unitPrice,
				unitOfMeasurement: data.measurementUnit,
				unitPriceConversion: data.unitPriceConversion,
				unitOfConversion: data.conversionUnit,
				updatedBy: localStorage.getItem("userId"),
				history: {
					unitPrice: data.unitPrice,
					unitOfMeasurement: data.measurementUnit,
					unitPriceConversion: data.unitPriceConversion,
					unitOfConversion: data.conversionUnit,
					user: localStorage.getItem("userId"),
				},
				productionAvailable: data.productionAvailable,
				inventoryAvailable: data.inventoryAvailable,
				logisticsAvailable: data.logisticsAvailable,
				franchise: data.franchise || franchise,
				code: data.code,
				plants: data.plants,
			};

			if (data.productionAvailable) {
				formData.productionOrderNumber = data.productionOrderNumber;
			} else {
				formData.productionOrderNumber = undefined;
			}

			if (data.inventoryAvailable) {
				formData.inventoryUnitOfMeasurement = data.inventoryUnitOfMeasurement;
			} else {
				formData.inventoryUnitOfMeasurement = undefined;
			}

			let url = api + "/cog/update/" + props.match.params.id;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			await axios.patch(url, formData);
			openNotification("success", "Success", "Cog updated");
			setTimeout(() => {
				setLoading(false);
				props.history.push("/cog/list");
			}, 1000);
		} catch (err) {
			console.log(err);
			setLoading(false);
			openNotification("error", "Error", "Error while trying to update cog");
			console.error(err.message);
			return null;
		}
	};

	const sixPointDecimal = (number) => Number(number).toFixed(4);

	const onChangeUnit = (value) => {
		let price = form.getFieldValue("unitPrice") || 0;
		if (value === "ton") {
			setOptionsConversion(
				optionsUnit.filter((o) => {
					return o.value === "lb";
				}),
			);
			form.setFieldsValue({ conversionUnit: "lb" });
			onChangeUnitPrice(price);
			setDisabled(true);
		} else if (value === "lb") {
			setOptionsConversion(
				optionsUnit.filter((o) => {
					return o.value === "lb";
				}),
			);
			form.setFieldsValue({ conversionUnit: "lb" });
			onChangeUnitPrice(price);
			setDisabled(true);
		} else if (value === "gl") {
			setOptionsConversion(
				optionsUnit.filter((o) => {
					return o.value === "gl" || o.value === "oz";
				}),
			);
			form.setFieldsValue({ conversionUnit: "gl" });
			onChangeUnitPrice(price);
			setDisabled(false);
		} else if (value === "oz") {
			setOptionsConversion(
				optionsUnit.filter((o) => {
					return o.value === "gl" || o.value === "oz";
				}),
			);
			form.setFieldsValue({ conversionUnit: "oz" });
			onChangeUnitPrice(price);
			setDisabled(false);
		}
	};

	const onChangeUnitConversion = (value) => {
		if (value === "gl" || value === "oz") {
			let price = form.getFieldValue("unitPrice") || 0;
			onChangeUnitPrice(price);
		}
	};

	const onChangeUnitPrice = (e) => {
		let totalPrice = 0;
		let measurement = form.getFieldValue("measurementUnit");
		let conversion = form.getFieldValue("conversionUnit");
		let price = e || 0;
		if (measurement === "ton" && conversion === "lb") {
			totalPrice = parseFloat(price) / 2000;
			form.setFieldsValue({ unitPriceConversion: sixPointDecimal(totalPrice) });
		} else if (measurement === "lb" && conversion === "lb") {
			totalPrice = parseFloat(price);
			form.setFieldsValue({ unitPriceConversion: sixPointDecimal(totalPrice) });
		} else if (measurement === "gl" && conversion === "oz") {
			totalPrice = parseFloat(price) / 128;
			form.setFieldsValue({ unitPriceConversion: sixPointDecimal(totalPrice) });
		} else if (measurement === "gl" && conversion === "gl") {
			totalPrice = parseFloat(price);
			form.setFieldsValue({ unitPriceConversion: sixPointDecimal(totalPrice) });
		} else {
			form.setFieldsValue({ unitPriceConversion: 0 });
		}
	};

	const deleteCog = async () => {
		setLoading(true);

		const url = api + "/cog/delete/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			await axios.delete(url);
			openNotification("info", "Info", "Cog Deleted");
			setTimeout(() => {
				setLoading(false);
				props.history.push("/cog/list");
			}, 1000);
		} catch (err) {
			setLoading(false);
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		updateCog(values);
	};

	const onChangeAvailableProduction = (e) => {
		setAvailableProduction(e.target.checked);
	};

	const onChangeAvailableInventory = (e) => {
		setAvailableInventory(e.target.checked);
	};

	const onChangeAvailableLogistics = (e) => {
		setAvailableLogistics(e.target.checked);
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Material Name"
							name="material"
							rules={[
								{
									required: true,
									message: "Please fill material name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Plants"
							name="plants"
							rules={[
								{
									required: true,
									message: "Please select at least one plant",
								},
							]}
						>
							<Select
								mode="multiple"
								showSearch
								placeholder={`Select plants`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={plants}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Measurement Unit"
							name="measurementUnit"
							rules={[
								{
									required: true,
									message: "Please select measurement unit",
								},
							]}
						>
							<Select
								size="large"
								options={optionsMeasurement}
								placeholder="Please select unit"
								onChange={onChangeUnit}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Conversion Unit"
							name="conversionUnit"
							rules={[
								{
									required: true,
									message: "Please select conversion unit",
								},
							]}
						>
							<Select
								size="large"
								options={optionsConversion}
								placeholder="Please select unit"
								disabled={disabled}
								onChange={onChangeUnitConversion}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							name="unitPrice"
							label="Unit Price"
							rules={[
								{
									required: true,
									message: "Please fill unit price",
								},
							]}
						>
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								formatter={(value) =>
									`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, "")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
								onChange={onChangeUnitPrice}
								min={0}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item name="unitPriceConversion" label="Unit Price Conversion">
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								formatter={(value) =>
									`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, "")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
								disabled
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Franchise"
							name="franchise"
							rules={[
								{
									required: true,
									message: "Please select franchise",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select franchise`}
								optionFilterProp="children"
								size="large"
								options={franchises57Options}
								allowClear={false}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Code"
							name="code"
							rules={[
								{
									max: 16,
									message: "Code cannot exceed 16 characters",
								},
							]}
						>
							<Input size="large" maxLength={16} />
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Title level={3}>Production</Title>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Production Available"
							name="productionAvailable"
							valuePropName="checked"
						>
							<Checkbox onChange={(e) => onChangeAvailableProduction(e)}>
								Is Available for Production Check In?
							</Checkbox>
						</Form.Item>
					</Col>
					{availableProduction && (
						<Col span={12}>
							<Form.Item
								name="productionOrderNumber"
								label="Production Number Order"
								rules={[
									{ required: true, message: "Order Number is required" },
								]}
							>
								<InputNumber size="large" style={{ width: "100%" }} min={0} />
							</Form.Item>
						</Col>
					)}
				</Row>
				<Divider />
				<Title level={3}>Inventory</Title>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Inventory Available"
							name="inventoryAvailable"
							valuePropName="checked"
						>
							<Checkbox onChange={(e) => onChangeAvailableInventory(e)}>
								Is Available for Inventory?
							</Checkbox>
						</Form.Item>
					</Col>
					{availableInventory && (
						<Col span={12}>
							<Form.Item
								name="inventoryUnitOfMeasurement"
								label="Inventory Unit of Measurement"
								rules={[
									{
										required: true,
										message: "Unit of Measurement is required",
									},
								]}
							>
								<Select
									size="large"
									options={optionsMeasurement}
									placeholder="Please select unit"
								/>
							</Form.Item>
						</Col>
					)}
				</Row>
				<Divider />
				<Title level={3}>Logistics</Title>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Logistics Available"
							name="logisticsAvailable"
							valuePropName="checked"
						>
							<Checkbox onChange={(e) => onChangeAvailableLogistics(e)}>
								Is Available for Logistics?
							</Checkbox>
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Title level={3}>History</Title>
				<CustomTable columns={columns} data={historyData} isScroll={false} />
				<Divider />
				<Row gutter={16}>
					<Col>
						<Button
							type="primary"
							htmlType="submit"
							loading={loading}
							size="large"
						>
							Save
						</Button>
					</Col>
					{localStorage.getItem("email") === "eliud@gmail.com" && (
						<Col>
							<Popconfirm
								title="Delete cog"
								description="Are you sure to delete this cog?"
								okText="Yes"
								cancelText="No"
								onConfirm={deleteCog}
							>
								<Button
									danger
									type="primary"
									htmlType="button"
									loading={loading}
									size="large"
								>
									Delete
								</Button>
							</Popconfirm>
						</Col>
					)}
				</Row>
			</Form>
		);
	};

	return (
		<Layout title="Edit Cog" description="Cog" type="medium">
			{contextHolder}
			<CustomForm />
		</Layout>
	);
};

export default Cog;
